import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0F] border-t border-[#FF6B0033] py-10 px-4" data-id="element-91">
      <div className="max-w-3xl mx-auto text-center" data-id="element-92">
        <div className="text-[#FF6B00] text-2xl font-black tracking-widest mb-4" data-id="element-93">
          🏐 EDULABS™
        </div>
        <p className="text-[#B0B0C0] text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-94">
          El sistema de entrenamiento N°1 para entrenadores de vóley.
        </p>
        <p className="text-[#B0B0C0] text-sm italic mb-6" data-id="element-95">
          Porque entrenar vóley no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-[#FF6B00] mb-6 font-medium" data-id="element-96">
          <span data-id="element-97">📧 soporte.edulabs@gmail.com</span>
          <span className="hidden sm:inline text-[#B0B0C0]" data-id="element-98">•</span>
          <span data-id="element-99">📲 @edulabs.oficial</span>
          <span className="hidden sm:inline text-[#B0B0C0]" data-id="element-100">•</span>
          <span data-id="element-101">🌐 www.edulabs.online</span>
        </div>

        <div className="h-px bg-[#FF6B0033] mb-6" data-id="element-102" />
        <p className="text-[#B0B0C0] text-xs mb-2" data-id="element-103">
          © EDULABS™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[#B0B0C0] text-xs opacity-70 mb-6" data-id="element-104">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}